/* unplugin-vue-components disabled */import script from "./swiper-box.vue?vue&type=script&lang=jsx"
export * from "./swiper-box.vue?vue&type=script&lang=jsx"

import "./swiper-box.vue?vue&type=style&index=0&id=eadb776a&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eadb776a"]])

export default __exports__